import React from "react";
import { graphql } from "gatsby";
import Page from "~/models/page";
import Frame from "~/views/layout/frame";
import SEO from "~/views/components/generic/seo";
import structuredData from "~/helpers/structured-data";
import formatdate from "~/helpers/formatdate";
import Navigation from "~/views/compositions/navigation";
import Breadcrumbs from "~/views/compositions/breadcrumbs";
import MarkdownRenderer from "~/views/components/content/markdown";

type Props = {
  data: any; // Updated to use any since the generated types may not be available yet
};

const NewsPage = ({ data }: Props) => {
  const page = new Page(data.page);

  return (
    <Frame>
      <Navigation />
      <Breadcrumbs urls={page.breadcrumb} className="hidden lg:flex" />
      <div className="mx-auto px-4 lg:px-8 max-w-[1096px]">
        <div className="shrink-0 flex-1 mx-auto">
          <div className="flex flex-col gap-5 lg:py-10">
            <h1 className="font-[800] text-[22px] lg:text-[38px] leading-[1.6em] palt">
              {page.title}
            </h1>
            <time className="font-[300] text-[14px]">
              {formatdate(page.createdAt)}
            </time>
          </div>
        </div>

        <div className="shrink-0 flex-1 py-10 mx-auto">
          <MarkdownRenderer
            id="content"
            content={page.content}
            references={page.references}
          />
        </div>
      </div>
    </Frame>
  );
};

export default NewsPage;

export const Head = ({ data }: Props) => {
  const page = new Page(data.page);
  const sd = structuredData(page);

  return <SEO page={page} sd={sd} />;
};

export const query = graphql`
  query NewsPage($id: String) {
    page: pageMdx(filter: { frontmatter: { id: { eq: $id } } }) {
      ...PageFields
    }
  }
`;
